export const status = [
  { code: 0, label: 'inactive'},
  { code: 1, label: 'active'},
];